import { render } from "./UserCreationFormRadioButton.vue?vue&type=template&id=50fd90c3&scoped=true"
import script from "./UserCreationFormRadioButton.vue?vue&type=script&lang=js"
export * from "./UserCreationFormRadioButton.vue?vue&type=script&lang=js"

import "./UserCreationFormRadioButton.vue?vue&type=style&index=0&id=50fd90c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fd90c3"]])

export default __exports__